import { useQuery } from "@tanstack/react-query";

import { ListBookAuthorsQueryFilters, UseListBookAuthorsQueryOptions } from "./types";
import { getBookAuthorsService  } from "./service";

export const listBookAuthorsQueryKey = ["book_contributor_admin"];

export function useListBookAuthorsQuery(
  filters?: ListBookAuthorsQueryFilters,
  options?: UseListBookAuthorsQueryOptions
) {

  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listBookAuthorsQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getBookAuthorsService(filters),
    ...options,
  });
}
